import React from "react";
import InboxIcon from "@src/lib/icons/18px/inbox";
import LineChartIcon from "@src/lib/icons/18px/line-chart";
import CircleCheckmarkFillIcon from "@src/lib/icons/18px/circle-checkmark-fill";
import EyeClosedIcon from "@src/lib/icons/18px/eye-closed";
import ProgressIndicator2FillIcon from "@src/lib/icons/18px/progress-indicator-2-fill";
import { GuestFeedbackCorrectiveActionStatus } from "@src/types.generated";

export type StatusDisplay = {
  label: string;
  Icon: React.FC<{ className?: string }>;
  // Pill background + text tone, and the icon tint within it.
  pillClassName: string;
  iconClassName: string;
};

export const STATUS_DISPLAY: Record<
  GuestFeedbackCorrectiveActionStatus,
  StatusDisplay
> = {
  [GuestFeedbackCorrectiveActionStatus.Pending]: {
    label: "Inbox",
    Icon: InboxIcon,
    pillClassName: "bg-gray-1 text-gray-12",
    iconClassName: "text-gray-12",
  },
  [GuestFeedbackCorrectiveActionStatus.InProgress]: {
    label: "In progress",
    Icon: ProgressIndicator2FillIcon,
    pillClassName: "bg-blue-1 text-blue-9",
    iconClassName: "text-blue-9",
  },
  [GuestFeedbackCorrectiveActionStatus.MeasuringImpact]: {
    label: "Measuring impact",
    Icon: LineChartIcon,
    pillClassName: "bg-purple-1 text-purple-7",
    iconClassName: "text-purple-7",
  },
  [GuestFeedbackCorrectiveActionStatus.Completed]: {
    label: "Done",
    Icon: CircleCheckmarkFillIcon,
    pillClassName: "bg-green-2 text-green-11",
    iconClassName: "text-green-9",
  },
  [GuestFeedbackCorrectiveActionStatus.Rejected]: {
    label: "Dismissed",
    Icon: EyeClosedIcon,
    pillClassName: "bg-gray-1 text-gray-12",
    iconClassName: "text-gray-12",
  },
};
